import { useState } from 'react'
import isNumber from 'lodash/isNumber'
import styled from 'styled-components'
import {
  GqlUserScrapCountsDocument,
  GqlViewerScrappedAnalysisReportsDocument,
  useGqlDeleteAllAnalysisReportScrapsMutation,
  useGqlViewerScrappedAnalysisReportsQuery,
} from 'generated/graphql'
import AnalysisResultItem from '@app.feature/companyAnalysis/components/AnalysisResultItem'
import AnalysisResultItemSkeleton from '@app.feature/companyAnalysis/components/AnalysisResultItemSkeleton'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { LIST_PAGE_SIZE } from 'constants/paginations'
import useFlutterInappwebview from 'hooks/useFlutterInappwebview'
import Pagination from '../../../../../components/Pagination'
import { useScrapStateContext } from '../../../../../screens/ScrapScreen/useScrapState'
import ScrapDeleteAllModal from '../../component/ScrapDeleteAllModal'
import ScrapListNotFound from '../../screen/ScrapListNotFound'

const AnalysisScrapListMobile = () => {
  const isWebview = useIsWebview()
  const { fluterInappwebview } = useFlutterInappwebview()
  const context = useScrapStateContext()
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)
  const { pagination, page } = context

  const { data, loading, variables, error } =
    useGqlViewerScrappedAnalysisReportsQuery({
      variables: {
        pagination: {
          page,
          pageSize: LIST_PAGE_SIZE,
        },
      },
      fetchPolicy: 'cache-and-network',
    })

  const [deleteAllAnalysisReportScraps] =
    useGqlDeleteAllAnalysisReportScrapsMutation()

  const totalCount = data?.viewerScrappedAnalysisReports.totalCount
  if (isNumber(totalCount)) {
    pagination.setNumberOfPages(Math.ceil(totalCount / LIST_PAGE_SIZE))
    window.scrollTo(0, 0)
  }

  async function handleDeleteAllUserScraps() {
    await deleteAllAnalysisReportScraps({
      refetchQueries: [
        {
          query: GqlUserScrapCountsDocument,
        },
        {
          query: GqlViewerScrappedAnalysisReportsDocument,
          variables,
        },
      ],
    })

    if (isWebview) {
      fluterInappwebview?.callHandler('reportRemoveAllScraps')
    }
    setShowDeleteAlert(false)
  }

  const handleShowDeleteAlert = () => {
    setShowDeleteAlert((prev) => !prev)
  }

  if (
    !data ||
    data?.viewerScrappedAnalysisReports.nodes.length === 0 ||
    error
  ) {
    return <ScrapListNotFound />
  }

  return (
    <StyledWrapper>
      <div>
        <div className="button-box">
          <button
            type="button"
            className="delete-button"
            onClick={handleShowDeleteAlert}
          >
            모두삭제
          </button>
        </div>
        <div className="divider" />
        <div className="list-wrapper">
          {loading
            ? Array.from({ length: 5 }, (_, index) => (
                <AnalysisResultItemSkeleton key={index} />
              ))
            : data.viewerScrappedAnalysisReports.nodes.map((item) => (
                <AnalysisResultItem
                  key={item.id}
                  item={item}
                  isScrapScreen={true}
                />
              ))}
        </div>
      </div>
      {data.viewerScrappedAnalysisReports.nodes.length > 0 && (
        <Pagination pagination={pagination} />
      )}
      <ScrapDeleteAllModal
        open={showDeleteAlert}
        onClose={handleShowDeleteAlert}
        onConfirm={handleDeleteAllUserScraps}
      >
        <DeleteDialogContent>
          잠깐, 스크랩한{' '}
          <span className="primary-text">{totalCount}건의 기업분석자료</span>
          를<br /> 모두 삭제하실건가요?
        </DeleteDialogContent>
      </ScrapDeleteAllModal>
    </StyledWrapper>
  )
}

export default AnalysisScrapListMobile

const StyledWrapper = styled.div`
  margin-top: 0px;

  .button-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
    padding: 0 20px;
    height: 0px;
    gap: 0px;
  }

  .delete-button {
    background: none;
    border: none;
    min-width: 50px;
    height: 36px;
    font-size: 14px;
    line-height: 1.86;
    letter-spacing: -0.56px;
    transform: translate(0, -72px);
    font-weight: 400;
    color: #333;
  }

  .divider {
    border: none;
    height: 1px;
    background-color: #eeeeee;
    margin: 0px;
  }
  .list-wrapper {
    padding: 0px 20px;
  }

  .calendar-button {
    font-size: 12px;
    letter-spacing: -0.2px;
    width: inherit;
    height: 36px;
    transform: translate(0, -72px);
    padding: 8px 13px;
    margin-right: 16px;
  }
`

const DeleteDialogContent = styled.div`
  text-align: center;
  .primary-text {
    font-size: inherit;
    font-weight: inherit;
    color: #01a0ff;
  }
`
